Ext.define('SA.DataSearchEditionOption', {
    singleton: true,

    forYear(year) {
        return new SA.DataSearchNonLatestEditionOption({year: Number(year)});
    },

    latest() {
        return new SA.DataSearchLatestEditionOption();
    }
});

Ext.define('SA.DataSearchLatestEditionOption', {
    equals(otherEdition) {
        return otherEdition?.isLatest();
    },

    getYearFacetValue() {
        return 'Latest';
    },

    getYearOrText(text) {
        return text;
    },

    isLatest() {
        return true;
    }
});

Ext.define('SA.DataSearchNonLatestEditionOption', {
    constructor({year}) {
        this.year = year;
    },

    equals(otherEdition) {
        return !otherEdition?.isLatest() && otherEdition?.getYear() === this.getYear();
    },

    getYearFacetValue() {
        return String(this.getYear());
    },

    getYear() {
        return this.year;
    },

    getYearOrText() {
        return this.getYear();
    },

    isLatest() {
        return false;
    }
});